import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-2-unread"} maskId="square-filled-radius-0-stroke-1-IconEmail2Unread"><path d="M22 4V7.55664L21.7266 7.69629L12.2266 12.5176L12 12.6318L11.7734 12.5176L3 8.06348V19H12V20H2V4H22Z" fill="currentColor"/><circle cx="19.5" cy="17.5" r="3.5" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail2Unread;
